<template>
    <div>
        <div class="flex items-center gap-2">
            <button
                ref="trigger"
                type="button"
                class="h-11 w-11 flex-none rounded-lg border-2 border-theme-muted cursor-pointer"
                :style="{ background: isValid ? value : 'transparent' }"
                @click="toggle"
            ></button>

            <input
                :value="value"
                type="text"
                :placeholder="placeholder"
                maxlength="7"
                class="w-full min-w-0 rounded-lg border px-3 py-2 text-base outline-none bg-theme-input text-theme-base"
                :class="
                    value && !isValid
                        ? 'border-theme-danger'
                        : 'border-theme-border'
                "
                @input="onTextInput"
            />
        </div>

        <div
            v-if="isOpen"
            ref="panel"
            class="fixed z-600 rounded-lg border border-theme-border bg-theme-card p-3 shadow-lg"
            :style="panelStyle"
        >
            <v-swatches
                :value="value"
                swatches="text-advanced"
                inline
                @input="select"
            />
        </div>
    </div>
</template>

<script>
import VSwatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.css";

import { isHexColor } from "@/common/lib/color";

export default {
    name: "ColorInput",
    components: { VSwatches },
    model: {
        prop: "value",
        event: "input"
    },
    props: {
        value: {
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: "#000000"
        }
    },
    data() {
        return {
            isOpen: false,
            panelStyle: {}
        };
    },
    computed: {
        isValid() {
            return isHexColor(this.value);
        }
    },
    beforeDestroy() {
        document.removeEventListener("click", this.onDocumentClick);
    },
    methods: {
        toggle() {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        },
        open() {
            this.isOpen = true;
            this.$nextTick(() => {
                const rect = this.$refs.trigger.getBoundingClientRect();
                const panelWidth = this.$refs.panel?.offsetWidth ?? 0;
                const padding = 12;
                const maxLeft = window.innerWidth - panelWidth - padding;
                this.panelStyle = {
                    top: `${rect.bottom + 8}px`,
                    left: `${Math.min(rect.left, Math.max(maxLeft, padding))}px`
                };
                document.addEventListener("click", this.onDocumentClick);
            });
        },
        close() {
            this.isOpen = false;
            document.removeEventListener("click", this.onDocumentClick);
        },
        onDocumentClick(event) {
            if (this.$el.contains(event.target)) return;
            this.close();
        },
        select(color) {
            this.$emit("input", color);
        },
        onTextInput(event) {
            this.$emit("input", event.target.value);
        }
    }
};
</script>
